import { createAction } from 'app-components/flux/core/actionHelpers';

export const getPreferencesV2 = createAction(
  'GET_PREFERENCES_V2',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getPreferencesV2Success = createAction('GET_PREFERENCES_V2_SUCCESS');
export const getPreferencesV2Failure = createAction('GET_PREFERENCES_V2_FAILURE');

export const getSpecificPreferenceV2 = createAction(
  'GET_SPECIFIC_PREFERENCES_V2',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getSpecificPreferenceV2Success = createAction('GET_SPECIFIC_PREFERENCES_V2_SUCCESS');
export const getSpecificPreferenceV2Failure = createAction('GET_SPECIFIC_PREFERENCES_V2_FAILURE');

export const updatePreferenceCriteria = createAction(
  'UPDATE_PREFERENCE_CRITERIA',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const updatePreferenceCriteriaSuccess = createAction(
  'UPDATE_PREFERENCE_CRITERIA_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const updatePreferenceCriteriaFailure = createAction('UPDATE_PREFERENCE_CRITERIA_FAILURE');

export const updatePreferenceOverride = createAction(
  'UPDATE_PREFERENCE_OVERRIDE',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const updatePreferenceOverrideSuccess = createAction(
  'UPDATE_PREFERENCE_OVERRIDE_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const updatePreferenceOverrideFailure = createAction('UPDATE_PREFERENCE_OVERRIDE_FAILURE');

export const applyPreferenceChanges = createAction(
  'APPLY_PREFERENCE_CHANGES',
  (payload) => payload,
  (payload, metadata) => metadata,
);

export const resetPreferenceOverride = createAction(
  'RESET_PREFERENCE_OVERRIDE',
  (payload) => payload,
  (payload, metadata) => metadata,
);
